/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Phase_DiscoverInputs */

const en_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover`)
};

const de_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken`)
};

const fr_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrir`)
};

const es_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrir`)
};

const it_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri`)
};

const nl_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdekken`)
};

const pl_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkrywaj`)
};

const fi_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutustu`)
};

const da_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk`)
};

const sv_nav_phase_discover = /** @type {(inputs: Nav_Phase_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska`)
};

/**
* | output |
* | --- |
* | "Discover" |
*
* @param {Nav_Phase_DiscoverInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_phase_discover = /** @type {((inputs?: Nav_Phase_DiscoverInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Phase_DiscoverInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_phase_discover(inputs)
	if (locale === "fr") return fr_nav_phase_discover(inputs)
	if (locale === "es") return es_nav_phase_discover(inputs)
	if (locale === "it") return it_nav_phase_discover(inputs)
	if (locale === "nl") return nl_nav_phase_discover(inputs)
	if (locale === "pl") return pl_nav_phase_discover(inputs)
	if (locale === "fi") return fi_nav_phase_discover(inputs)
	if (locale === "da") return da_nav_phase_discover(inputs)
	if (locale === "sv") return sv_nav_phase_discover(inputs)
	return en_nav_phase_discover(inputs)
});